import AutocompleteZ from '@/components/forms/AutocompleteZ.vue'
import ActionsForm from '@/shared/mixins/actionsForm'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpensezpag/mixins/ExpenseMixin'
export default {
  name: 'ExpenseSearch',
  components: {AutocompleteZ},
  mixins: [ ActionsForm, ExpenseMixin ],
  data () {
    return {
      dataStatusDespesa: [],
      form: {
        lote: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        },
        dataLote: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        },
        funcionarioId: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        }
      }
    }
  },
  methods: {
    Search () {
      this.$emit('search', {Lote: this.form.lote.value, DataLote: this.form.dataLote.value, FuncionarioId: this.form.funcionarioId.value})
    },
    onClearSection () {
      this.form.lote.value = null
      this.form.dataLote.value = null
      this.$refs.favorecidoTypeahead.clear()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/miscellaneousreimbursement/components/Filtermiscellaneouslots/Filtermiscellaneouslots.js